import {MAP_MODE} from '@src/constants/map.ts';
import {useLocation} from 'react-router';

const useMapMode = () => {
  const location = useLocation();

  const [basePath] = location.pathname.slice(1).split('/');

  let mapMode = '';

  switch (basePath) {
    case 'mosaics':
      mapMode = MAP_MODE.MOSAICS;
      break;
    case 'explorer':
      mapMode = MAP_MODE.SEARCH;
      break;
    case 'aois':
      mapMode = MAP_MODE.FEATURES;
      break;
    case 'browse':
    case 'visualize':
    case 'analyze':
      mapMode = MAP_MODE.ANALYZE;
      break;
    case 'subscriptions':
      mapMode = MAP_MODE.SUBSCRIPTIONS;
      break;
    case 'saved-searches':
      mapMode = MAP_MODE.SAVED_SEARCHES;
      break;
    default:
      mapMode = '';
  }

  return {
    mapMode,
    isMosaicsMode: mapMode === MAP_MODE.MOSAICS,
    isSearchMode: mapMode === MAP_MODE.SEARCH,
    isFeaturesMode: mapMode === MAP_MODE.FEATURES,
    isAnalyzeMode: mapMode === MAP_MODE.ANALYZE,
  };
};

export default useMapMode;
